import { BusinessUploadForm } from './BusinessUploadForm';
import { IndividualUploadForm } from './IndividualUploadForm';

interface UploadFormProps {
  readonly businessType: 'individual' | 'business';
}

function UploadForm({ businessType }: UploadFormProps) {
  return businessType === 'business' ? <BusinessUploadForm /> : <IndividualUploadForm />;
}

export { UploadForm };
